import { Box, Fade } from '@material-ui/core'

import styled from 'styled-components'
import { shape } from '../../theme'

const SelectedNodeRoot = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	background: rgba(255,255,255,0.25);
	color: white;

	padding: 4px 12px;

	border-radius: ${shape.borderRadius};

	white-space: nowrap;
`

export default function SelectedNode({ selectedNode = undefined as any }) {
	return (
		<Fade in={Boolean(selectedNode)}>
			<SelectedNodeRoot>
				<Box fontFamily="Segoe UI Emoji">{selectedNode?.symbol || ''}</Box>
				<Box>{selectedNode?.name || ''}</Box>
			</SelectedNodeRoot>
		</Fade>
	)
}
